export function isScrolledIntoView(element, options) {
    var _a, _b;
    if (options === void 0) { options = {}; }
    var rect = element.getBoundingClientRect();
    var parantRect = (_a = options.parent) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    var parentTop = (parantRect === null || parantRect === void 0 ? void 0 : parantRect.top) || 0;
    var parentHeight = ((_b = options === null || options === void 0 ? void 0 : options.parent) === null || _b === void 0 ? void 0 : _b.scrollHeight) || window.innerHeight;
    var elemTop = rect.top + ((options === null || options === void 0 ? void 0 : options.top) || 0);
    var elemBottom = rect.bottom + ((options === null || options === void 0 ? void 0 : options.bottom) || 0);
    var isVisible = (elemTop >= parentTop) && (elemBottom <= parentHeight);
    return isVisible;
}
export function isVisible(element, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var rect = element.getBoundingClientRect();
    var parentRect = (_a = options.parent) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    var parentTop = (parentRect === null || parentRect === void 0 ? void 0 : parentRect.top) || 0;
    var parentBottom = (parentRect === null || parentRect === void 0 ? void 0 : parentRect.bottom) || window.innerHeight;
    var elemTop = rect.top + ((options === null || options === void 0 ? void 0 : options.top) || 0);
    var elemBottom = rect.bottom + ((options === null || options === void 0 ? void 0 : options.bottom) || 0);
    var isVisible = (elemTop >= parentTop) && (elemBottom <= parentBottom);
    return isVisible;
}
